import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";

import { addCategory } from "../../../../../services/Admin/MenuApi";

const AddCategoryDialog = ({ open, onClose, onAdded }) => {
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [image, setImage] = useState(null);
	const [status, setStatus] = useState(1);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");

	const resetForm = () => {
		setName("");
		setDescription("");
		setImage(null);
		setStatus(1);
		setError("");
		setSuccess("");
	};

	const handleFileChange = (e) => {
		const f = e.target.files && e.target.files[0];
		setImage(f || null);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError("");
		setSuccess("");
		try {
			const res = await addCategory({
				name,
				name_en: "",
				description,
				description_en: "",
				image,
				status,
			});

			setSuccess(res?.message || "تم الإضافة بنجاح");
			if (typeof onAdded === "function") onAdded(res?.data || null);
			// keep dialog open so user can add more; clear form
			resetForm();
		} catch (err) {
			setError(err?.message || "فشل في إضافة الفئة");
		} finally {
			setLoading(false);
		}
	};

	const handleClose = () => {
		resetForm();
		if (typeof onClose === "function") onClose();
	};

	return (
		<Dialog open={Boolean(open)} onClose={handleClose} fullWidth maxWidth="sm">
			<DialogTitle>إضافة فئة جديدة</DialogTitle>
			<DialogContent>
				<Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, display: "grid", gap: 2 }}>
					{error && <Alert severity="error">{error}</Alert>}
					{success && <Alert severity="success">{success}</Alert>}

					<TextField label="الاسم" value={name} onChange={(e) => setName(e.target.value)} fullWidth required />
					<TextField label="الوصف" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline rows={3} />

					<Box>
						<input accept="image/*" id="category-image" type="file" onChange={handleFileChange} />
					</Box>

					<FormControlLabel control={<Switch checked={Boolean(Number(status))} onChange={(e) => setStatus(e.target.checked ? 1 : 0)} />} label="متاح" />

					<Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
						<Button onClick={handleClose} color="inherit">إلغاء</Button>
						<Button type="submit" variant="contained" disabled={loading}>
							{loading ? <CircularProgress size={20} /> : "حفظ"}
						</Button>
					</Box>
				</Box>
			</DialogContent>
			<DialogActions />
		</Dialog>
	);
};

export default AddCategoryDialog;

